import { _ } from "libs";
import React, { useEffect, useState } from "react";
import withRedux from "../../withRedux";
import { RootState } from "../../reducers";
import { Card, Connected } from "../../types";
import CardList from "../../components/settings/cardList";
import CardForm from "../../components/settings/cardForm";
import { getPaymentCards, addCard, removeCard } from "../../actions";
import SubscriptionList from "../../components/settings/subscriptionList";
import Modal from "../../components/modal";

type Props = {
	cards: Card[];
	removeCard: Connected<typeof removeCard>;
	getPaymentCards: Connected<typeof getPaymentCards>;
};

const Billing = ({ cards, getPaymentCards, removeCard }: Props) => {
	const [showModal, setShowModal] = useState(false);

	const openModal = () => {
		setShowModal(true);
	};

	const closeModal = () => {
		setShowModal(false);
	};

	useEffect(() => {
		getPaymentCards();
	}, []);

	const onCardFormSubmit = async () => {
		await getPaymentCards();
		setShowModal(false);
	};

	const onCardRemoveClicked = (card: Card) => {
		const remove = window.confirm(_("billing.removeCardConfirmation"));
		if (remove) {
			const cardEl = document.getElementById(card.cardId);
			cardEl.style.display = "none";
			removeCard(card.cardId);
		}
	};

	return (
		<>
			{showModal ? (
				<Modal title={_("addCard.heading")} onCloseClicked={closeModal} className="scrollable">
					<CardForm onSubmit={onCardFormSubmit} />
				</Modal>
			) : null}
			<div className="h5WithAction">
				<h5>{_("billing.savedcards.heading")}</h5>
				<div className="link blue" onClick={openModal}>
					{_("addCardBtn")}
				</div>
			</div>
			<CardList cards={cards} onRemoveClicked={onCardRemoveClicked} />
			<h5>{_("billing.subscriptions.heading")}</h5>
			<SubscriptionList />
		</>
	);
};

export default withRedux({ removeCard, getPaymentCards }, ({ cards: { cards } }: RootState) => {
	return { cards };
})(Billing);
